import helpers from '../../util/helpers';

const searchOccasions = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Occasions Autocomplete
    const occasionsSearch = $('input.occasions-search');
    if (occasionsSearch.length) {
      occasionsSearch.each(function() {
        const _this = $(this);

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 1,
          showListName: false,
        });
      });

      occasionsSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      occasionsSearch.on('input', function() {
        const _this = $(this);

        if (_this.data('cookie-occasions') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-occasions'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);

        if (_this.data('cookie-occasions')) {
          helpers.docCookies.setItem(_this.data('cookie-occasions'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchOccasions;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchOccasions.js